function formExcelAdminEmpresas() {
  const selectizer = $('select[name="ultimafatura"]');
  const costCenter = $('#centroCustoUltimaFatura,#centrocusto');
  const all = $('#todoscampos');
  all.on('click', selectAll);
  costCenter.on('click', handlerClickButtonCostCenter);
  selectizer.on('change', changeExibition);
}

function selectAll(event) {
  const checked = $('#todoscampos').prop('checked');
  const costCenter1 = $('#centrocusto');
  const costCenter2 = $('#centroCustoUltimaFatura');
  const flag = costCenter2.prop('checked');
  const form = $(event.target.closest('form'));
  form.find('label').toggleClass('active', checked);
  form.find('input').prop('checked', checked);

  if(flag) {
  	costCenter1.prop('checked', false);
    costCenter1.closest('label').toggleClass('active', false);
  	costCenter2.prop('checked', checked);
    costCenter2.closest('label').toggleClass('active', checked);
  } else {
    costCenter1.closest('label').toggleClass('active', checked);
  	costCenter1.prop('checked', checked);
  	costCenter2.prop('checked', false);
    costCenter2.closest('label').toggleClass('active', false);
  }
}

function handlerClickButtonCostCenter(event) {
  const id1 = '#' + event.target.id;
  const id2 = (id1 == '#centrocusto') ? '#centroCustoUltimaFatura' : '#centrocusto';
  if($(id1).prop('checked')){
    $(id2).prop('checked', false);
    $(id2).closest('label').toggleClass('active', false);
  }
}

function changeExibition(event) {
  const costCenter = $('#centro-custo-ultima-fatura')
  const products = $('#produtos-usuarios-ultima-fatura')
  if($(event.target).val() == 0){
    costCenter.css('display','none')
    products.css('display','none')
  } else {
    costCenter.css('display','block')
    products.css('display','block')
  }
}

module.exports = {
  url: /^\/empresas\/\d+.*|^\/settings\/membros-de-equipe/,
  init: formExcelAdminEmpresas
}

